import {Component} from '@angular/core';
import {PesAccountService} from '@pes/ui';
import {StateService} from '@uirouter/angular';

/**
 * The PES default app component.
 */
@Component({
    selector: 'pes-root',
    templateUrl: './app.component.html'
})
export class AppComponent {

    constructor(private account: PesAccountService, private _state: StateService) {
    }

    /**
     * On fait un test aussi précis, sinon on a un effet de flash apparition / disparition du header / footer
     * pour le workflow03
     */
    public checkDisplayHeaderFooter(): boolean {
        return ((this._state.current.name === 'login') ||
            (this._state.current.name === 'password_forget') ||
            (this._state.current.name === 'recover') ||
            (this._state.current.name === 'forbidden') ||
            (this.account.isAuthenticated()
                && ((this.account.hasProfile('virtual_user')
                        && this._state.params.taskReference
                        && this._state.params.tpl !== 'workflow03')
                    || !this.account.hasProfile('virtual_user'))));
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts